<script lang="ts">
    import { Cell } from "@smui/data-table";

    import { _ } from "svelte-i18n";
    import IconButton, { Icon } from "@smui/icon-button";
    import { mdiAlertCircle } from "@mdi/js";

    export let errors = [];
    export let warnings = [];
    export let screenMode;
    export let country;
    export let currency;
    export let productCurrency;
    export let price;
    export let pricePromo;
    export let onlyOfferInd = 0;
    function nvl(val, ret) {
        if (val && val != null) {
            return val;
        } else {
            return ret && ret != null ? ret : "";
        }
    }

    function getFieldErrMsg(field, type) {
        if (type == "E") {
            return $_([...errors].filter((x) => x.field == field)[0].message);
        } else {
            return $_([...warnings].filter((x) => x.field == field)[0].message);
        }
    }

    function existsError(field, type) {
        if (type == "E") {
            return errors && errors != null && errors?.length > 0 && errors.map((x) => x.field).includes(field);
        } else {
            return warnings && warnings != null && warnings.length > 0 && warnings.map((x) => x.field).includes(field);
        }
    }
</script>

{#key currency}
    {#if (currency && currency != null) || productCurrency != null}
        <Cell data-qa={"price-cell-" + (currency || productCurrency || "default")} class="text-right right-splitter-sub">
            <!-- Price Regular -->
            {#if screenMode == "upload"}
                {#if existsError("price" + country, "E")}
                    <span class="red-text" title={getFieldErrMsg("price" + country, "E")}>{nvl(price, "-")}</span>
                {:else if productCurrency == null && price == null}
                    <span />
                {:else if productCurrency != null && price == null}
                    <span />
                {:else}
                    {#if onlyOfferInd == 1 && nvl(price, 0) != 0 }
                        <span class="orange-text">{nvl(price, "")}</span>
                    {:else}
                        <span>{nvl(price, "")}</span>
                    {/if}    
                {/if}
            {:else if productCurrency != null && price != null}
                {#if onlyOfferInd == 1 && nvl(price, 0) != 0 }
                    <span class="orange-text">{nvl(price, "-")}</span>
                {:else}
                    <span>{nvl(price, "-")}</span>
                {/if}    
            {:else}
                <span />
            {/if}

            <!-- Price Promo -->
            {#if screenMode == "upload"}
                {#if existsError("pricePromo" + country, "E")}
                    <span>(</span><span class="red-text" title={getFieldErrMsg("pricePromo" + country, "E")}>{nvl(pricePromo, "-")}</span><span>)</span>
                {:else if productCurrency == null && pricePromo == null}
                    <span />
                {:else if productCurrency != null && pricePromo == null}
                    <span />
                {:else}
                    {#if onlyOfferInd == 1 && nvl(pricePromo, 0) != 0 }
                        <span>(</span><span class="orange-text">{nvl(pricePromo, "")}</span><span>)</span>
                    {:else}
                        <span>(</span><span>{nvl(pricePromo, "")}</span><span>)</span>
                    {/if}    
                {/if}
            {:else if productCurrency != null && pricePromo != null}
                {#if onlyOfferInd == 1 && nvl(pricePromo, 0) != 0 }
                    <span>(</span><span class="orange-text">{nvl(pricePromo, "")}</span><span>)</span>
                {:else}
                    <span>(</span><span>{nvl(pricePromo, "")}</span><span>)</span>
                {/if}    
            {:else}
                <span />
            {/if}

            <!-- Currency -->
            {#if screenMode == "upload"}
                {#if existsError("currency" + country, "E")}
                    <span class="red-text" title={getFieldErrMsg("currency" + country, "E")}>{nvl(currency, "")}</span>
                {:else if (productCurrency == null && price == null && pricePromo == null) || (nvl(price, 0) == 0  && nvl(pricePromo, 0) == 0 && onlyOfferInd == 1)}
                    <span />
                {:else}
                    <span>{nvl(currency, "")}</span>
                {/if}
            {:else}
                {#if (productCurrency == null && price == null && pricePromo == null) || (nvl(price, 0) == 0  && nvl(pricePromo, 0) == 0 && onlyOfferInd == 1)}
                    <span />
                {:else}
                    <span>{nvl(productCurrency, "")}</span>
                {/if}
                {#if onlyOfferInd == 1 && nvl(price, 0) != 0 }
                    <span title={$_("only_offer_"+country.toLowerCase())} class="orange-text">
                        <IconButton size="mini" class="range-text pt-0 pb-0 pl-0 pr-0" disabled={true}>
                            <Icon tag="svg" viewBox="0 0 24 24" class="orange-text">
                            <path fill="currentColor" d={mdiAlertCircle} />
                            </Icon>
                        </IconButton>
                    </span>
                {/if}
            {/if}

        </Cell>
    {:else}
        <!-- Empty Cell -->
        <Cell class="text-right right-splitter-sub" />
    {/if}
{/key}

<style>
</style>
